import { ContentItem } from '@kentico/kontent-delivery';
import { IQuoteWithImageProps } from '../components/quote-with-image/quote-with-image';
import get from 'lodash/get';
import { Models } from '.';
import { IEmployeeBoxProps } from '../components/employee-box/employee-box';

export class QuoteWithImageModel extends ContentItem {
  get type(): string {
    return get(this._config, 'elements.type.value[0].codename', '');
  }

  get sectionTitle(): string {
    return get(this._config, 'elements.section_title.value', {});
  }

  get quoteTitle(): string {
    return get(this._config, 'elements.quote_title.value', {});
  }

  get quote(): string {
    return get(this._config, 'elements.quote.value', {});
  }

  get author(): IEmployeeBoxProps {
    const authorData = get(this._config, 'elements.author_value.value[0]', {});
    const modeledData = Models.EmployeeBoxModel.create(
      authorData as IEmployeeBox
    );

    return modeledData;
  }

  get id(): string {
    return get(this._config, 'elements.unique_id.value', '');
  }

  get additionamMarginInColumn(): string {
    return get(
      this._config,
      'elements.additional_margin__additional_margin_in_column.value[0].codename',
      ''
    );
  }

  get additionamMarginInRow(): string {
    return get(
      this._config,
      'elements.additional_margin__additional_margin_in_row.value[0].codename',
      ''
    );
  }

  public static create(data: IQuoteWithImage): IQuoteWithImageProps {
    const {
      sectionTitle,
      quoteTitle,
      quote,
      id,
      additionamMarginInColumn,
      additionamMarginInRow,
      type,
      author
    } = new QuoteWithImageModel(data);
    return {
      type,
      sectionTitle,
      quoteTitle,
      quote,
      author,
      id,
      additionamMarginInColumn,
      additionamMarginInRow
    };
  }
}
